import { render, staticRenderFns } from "./PaymentModalEventWrapper.vue?vue&type=template&id=51c25ad6&"
import script from "./PaymentModalEventWrapper.vue?vue&type=script&lang=js&"
export * from "./PaymentModalEventWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports